import * as React from 'react';
import { Res, TableOrderSaleCenterStatusDTO } from 'core/api';
import { ActionButtonDefinition, PosScreenClassComponent, ScreenSize } from 'pos/ui';
import * as Images from 'pos/Images';
import * as UI from 'core/ui';
import { Cols, Col } from 'core/ui';
import { Modal } from 'core/ui-next/modal';

type Props = {
	actualStatus: TableOrderSaleCenterStatusDTO[]
} & Modal.Actions<TableOrderSaleCenterStatusDTO[]>;

type State = {
	status: TableOrderSaleCenterStatusDTO[]
};

export default class TableOrderSaleCenterCommConfigurationScreen extends PosScreenClassComponent<Props, State> {

	private form = React.createRef<UI.Form<State>>();

	protected getScreenId(): string {
		return 'CONFIGURE_TABLE_ORDER_SALE_CENTERS';
	}

	protected getTitle(): string {
		return Res.Web.RESUME_OR_SUSPEND_TABLE_ORDER_COMMS();
	}
	protected getImage(): string | SvgIcon {
		return Images.SelectSaleLocation;
	}

	protected getSize(): ScreenSize {
		return 'medium';
	}

	onComponentDidMount(): void { }
	onComponentWillUnmount(): void { }

	createInitialState(props: Props): Nullable<State> {
		return { status: [...props.actualStatus] };
	}

	protected getActionButtonsDefs(): Nullable<ActionButtonDefinition>[] {
		return [
			this.cancelButton(),
			{ action: this.enableAll, image: Images.Resume, title: Res.Web.RESUME_OR_SUSPEND_TABLE_ORDER_ENABLE_ALL_BTN() },
			{ action: this.disableAll, image: Images.Suspend, title: Res.Web.RESUME_OR_SUSPEND_TABLE_ORDER_DISABLE_ALL_BTN() },
			null,
			null,
			this.okButton(this.onOK)
		];
	}

	protected useKeypad(): boolean {
		return false;
	}

	protected useKeyboard(): boolean {
		return true;
	}

	onOK = async () => {
		const valid = await this.form.current!.updateModel();
		if (valid)
			this.close(this.state.status);
	};

	enableAll = async () => {
		const newStatus: TableOrderSaleCenterStatusDTO[] = this.state.status.map(s => ({ ...s, IsEnabled: true }));
		this.setState({ status: newStatus }, () => this.form.current!.remountAll());
	};

	disableAll = async () => {
		const newStatus: TableOrderSaleCenterStatusDTO[] = this.state.status.map(s => ({ ...s, IsEnabled: false }));
		this.setState({ status: newStatus }, () => this.form.current!.remountAll());
	};

	onStatusChanged = (values: boolean[], index: number) => {
		const newStatus = this.state.status;
		newStatus[index].IsEnabled = values[0];
		this.setState({ status: newStatus }, () => this.form.current!.remount());
	};

	protected getContent(): React.ReactNode {
		const { Form, ComboBox, TextBox } = UI.controlsFor<State>();

		return <div className='p-sm'>
			<p >{Res.Web.RESUME_OR_SUSPEND_TABLE_ORDER_INFO_LBL()}</p>
			<hr />

			<Form ref={this.form} model={this.state} className='p-t-sm' >
				{this.state.status.map((s, i) => {
					return <Cols key={i} >
						<Col width='80' className='text-bolder' ><div className='control-label' style={{ textAlign: 'left' }}>{s.SaleCenterName}</div></Col>
						<Col width='150' className='m-r'><ComboBox linkTo={`status[${i}].IsEnabled`} options={[true, false]} format={x => x ? Res.Web.RESUME_OR_SUSPEND_TABLE_ORDER_ENABLED_LBL() : Res.Web.RESUME_OR_SUSPEND_TABLE_ORDER_DISABLED_LBL()} onValueChanged={values => this.onStatusChanged(values, i)} required /></Col>
						<Col width='*'>{s.IsEnabled ? null : <TextBox linkTo={`status[${i}].Message`} placeholder={Res.Msg.MSG_DEFAULT_SUSPEND_TABLE_ORDER_MESSAGE(s.SaleCenterName)} />}</Col>
					</Cols>;
				})}
			</Form>
		</div>;
	}
}